"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.wrapper = void 0;

var react_1 = require("@emotion/react");

exports.wrapper = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 0.5px rgba(0, 0, 0, 0.1);\n  object-fit: cover;\n"])));
var sizes = {
  md: react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 48px;\n    height: 48px;\n  "]))),
  sm: react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    width: 40px;\n    height: 40px;\n  "]))),
  xs: react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 32px;\n    height: 32px;\n  "])))
};

var size = function size(targetSize) {
  return sizes[targetSize];
};

exports.size = size;